import Time from './Time';

const reName = /^(.*?)((,|buss|statio|\(|hållplats).+)$/;

/**
 * Strips the station name from parts that just takes space
 * @param props name: original name to strip
 * @returns JSX.Element with shorter or same string
 */
const StripName = (props: { name: string; }): JSX.Element => {
	const { name } = props;
	let newname = name;
	let found = newname.match(reName);
	if (found) {
		newname = found[1]
	}
	found = newname.match(/^(.{20}).*$/);
	if (found) {
		newname = found[1] + "...";
	}
	return <>{newname}</>;
};

/**
 * Make vehicle name shorter.
 * @param props name: vehicle name
 * @returns JSX.Element with new text
 */
const StripVehicle = (props: { name: string; }): JSX.Element => {
	const { name } = props;
	let newname = name;
	let found = newname.match(/^(.+) - (.+)$/);
	if (found) {
		newname = found[2];
	}
	return <>{newname}</>;
};

const LegItem = (props: { item: any }) => {
	const { item } = props;
	return (
		<tr>
			<td style={{ overflow: 'hidden' }}>
				<StripName name={item.Origin?.name} />
			</td>
			<td>
				<Time time={item.Origin?.time} />
			</td>
			<td>
				<StripVehicle name={item.name} />
			</td>
			<td>
				<Time time={item.Destination?.time} />
			</td>
			<td style={{ overflow: 'hidden' }}>
				<StripName name={item.Destination?.name} />
			</td>
			<td></td>
		</tr>
	)

}

const LegList = (props: {
	leglist: any[];
}) => {
	const { leglist } = props;
	return (
		<table style={{ fontSize: '75%' }}>
			<thead>
				<tr>
					<th colSpan={2} style={{ textAlign: 'right' }}>Avgång</th>
					<th ></th>
					<th colSpan={2} style={{ textAlign: 'left' }}>Ankomst</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				{
					leglist.map((item: any, idx: number) => {
						return (
							<LegItem key={idx} item={item} />
						)
					})
				}
			</tbody>
		</table >
	);
};

export default LegList;